/** Constantes y utilidades puras del editor de capas. */

export const TYPE_COLOR = {
  BACKGROUND: "#64748B", IMAGE: "#FF4D4D", SHAPE: "#C084FC",
  TEXT: "#34D399", VECTOR: "#F59E0B", MASK: "#F472B6",
};

export const FONT_CLASS_CSS = {
  sans: "'Liberation Sans', Arial, Helvetica, sans-serif",
  serif: "'Liberation Serif', 'Times New Roman', Georgia, serif",
  mono: "'Liberation Mono', 'Courier New', monospace",
};

export const SEND_FORMATS = [
  ["png", "PNG"], ["jpg", "JPG"], ["webp", "WEBP"],
  ["svg", "SVG"], ["pdf", "PDF"], ["psd", "PSD"], ["zip", "ZIP"],
  ["pdf_full", "PDF completo (multipágina)"],
];

export const HANDLES = [
  ["nw", 0, 0, "nwse-resize"], ["n", 0.5, 0, "ns-resize"], ["ne", 1, 0, "nesw-resize"],
  ["e", 1, 0.5, "ew-resize"], ["se", 1, 1, "nwse-resize"], ["s", 0.5, 1, "ns-resize"],
  ["sw", 0, 1, "nesw-resize"], ["w", 0, 0.5, "ew-resize"],
];

export const FILTER_DEFAULTS = { brightness: 100, contrast: 100, saturation: 100 };

export const cssFilter = (f) => {
  if (!f) return "none";
  const { brightness = 100, contrast = 100, saturation = 100 } = f;
  if (brightness === 100 && contrast === 100 && saturation === 100) return "none";
  return `brightness(${brightness}%) contrast(${contrast}%) saturate(${saturation}%)`;
};

export const rgbToHex = (r, g, b) =>
  "#" + [r, g, b].map((v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0")).join("");
